import BaseService from '@/services/BaseService';

class SubmittalCoverPageService extends BaseService {
    getSubmittalCoverPage = () => this.get('/get-submittal-cover-page');

    addSubmittalCoverPage = (data) => this.post('/add-submittal-cover-page', data);
}

export default new SubmittalCoverPageService();
